import { v4 as uuidv4 } from 'uuid';
import { isNode } from './helpers/isNode';
const { deflateRaw } = require('pako/dist/pako_deflate.js');
function generateRandomXmlId() {
    return 'a' + uuidv4();
}
export function encodeSamlRequest({ xmlId = generateRandomXmlId(), consumerServiceUrl, audienceUri }) {
    const rawSamlRequest = `<samlp:AuthnRequest xmlns="urn:oasis:names:tc:SAML:2.0:metadata" xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol" ID="${xmlId}" Version="2.0" IssueInstant="2020-12-07T15:12:01.804Z" IsPassive="false" AssertionConsumerServiceURL="${consumerServiceUrl}"><Issuer xmlns="urn:oasis:names:tc:SAML:2.0:assertion">${audienceUri}</Issuer></samlp:AuthnRequest>`;
    const deflated = deflateRaw(rawSamlRequest);
    const b64encoded = isNode() ? Buffer.from(deflated).toString('base64') : require('buffer').Buffer.from(deflated).toString('base64');
    const encodedSAML = encodeURIComponent(b64encoded);
    return encodedSAML;
}
